import { render, staticRenderFns } from "./ui-carousel-slide.vue?vue&type=template&id=47536174&"
import script from "./ui-carousel-slide.vue?vue&type=script&lang=js&"
export * from "./ui-carousel-slide.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/django/skokka/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('47536174')) {
      api.createRecord('47536174', component.options)
    } else {
      api.reload('47536174', component.options)
    }
    module.hot.accept("./ui-carousel-slide.vue?vue&type=template&id=47536174&", function () {
      api.rerender('47536174', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "frontend/static/js/components/ui/carousel/ui-carousel-slide.vue"
export default component.exports